import { object, number, ValidationError } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object()
  .shape({
    bloodPressureDeviceId: number().nullable(),
    weightScaleDeviceId: number().nullable(),
    pulseOximeterDeviceId: number().nullable(),
    bloodGlucoseDeviceId: number().nullable(),
  })
  // validation for 'At least one device should be selected'
  .test({
    name: 'atLeastOneRequired',
    test: (value, { createError }) => {
      const fieldsList = [
        'bloodPressureDeviceId',
        'weightScaleDeviceId',
        'pulseOximeterDeviceId',
        'bloodGlucoseDeviceId',
      ];

      const errors = fieldsList.map(
        item => new ValidationError('Field is required', value[item], item),
      );

      return fieldsList.some(item => Boolean(value[item]))
        ? true
        : createError({ message: () => errors });
    },
  });

export default yupResolver(validationSchema);
